import React from 'react';
import omit from 'lodash/omit';
import { Box, Button, Text } from '@sparknz/spark-pattern-library';

import { useQuery } from 'shared/hooks';
import { StoreItemViewModel } from 'shared/types/store';
import { StoreStockBox, Subtitle } from './components';
import { Selection, StoreRow } from './StoreList.style';

type StoreListFieldProps = {
  stores: StoreItemViewModel[];
  setInfoLayerOpen: (open: boolean) => void;
  setSelectedStore: (store: StoreItemViewModel) => void;
};

const StoreList = ({
  stores,
  setSelectedStore,
  setInfoLayerOpen,
}: StoreListFieldProps) => {
  const { replaceQuery, query } = useQuery();

  const toggleMoreDetails = (storeId: string) => {
    setSelectedStore(stores?.find((s) => s.id === storeId));
    replaceQuery(omit(query, ['info']));
    setInfoLayerOpen(true);
  };

  return (
    <>
      {stores?.map((store) => (
        <StoreRow key={store.id}>
          <Selection>
            <Box>
              <Text variant="bodySDemi">{store.displayName}</Text>
              <Subtitle store={store} />
              <Button
                variant="textbutton"
                onClick={() => toggleMoreDetails(store.id)}
                type="button"
                data-testId={`toggle-${store.id}`}
              >
                See store hours
              </Button>
            </Box>
          </Selection>

          <StoreStockBox store={store} />
        </StoreRow>
      ))}
    </>
  );
};

export default StoreList;
